export const Logout = () => {
    return <h1>hello</h1>
}